import api from 'utils/api';

async function sendData(input: any) {
  if (import.meta.env.VITE_NODE_ENV === 'prod') {
    await api.post('/public/analytics', input);
  }
}

function getData(action: string, metaData?: any) {
  switch (action) {
    case 'PAGE_VIEW': {
      return { event: action, data: metaData };
      break;
    }
    case 'LOGIN': {
      const obj = {
        userId: localStorage.getItem('userId')
      };
      return { event: action, data: obj };
      break;
    }
    case 'SIGNUP':
      const obj = {
        userId: localStorage.getItem('userId')
      };
      return { event: action, data: obj };
      break;
    default:
      break;
  }
}

(window as any).myAntsTag = function myAntsTag(type: string, ...rest: any) {
  switch (type) {
    case 'EVENT': {
      const [action, metaData] = rest;
      const data = getData(action, metaData);
      sendData(data);
      break;
    }
    case 'SET': {
      const [key, value] = rest;
      localStorage.setItem(key, value);
      break;
    }
    default:
      break;
  }
};
